var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurnS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31803 5.15693H10.9917V5.99165H10.9875V9.79382H10.1569V9.78965H9.74791V11H9.33055H8.91319H3.08264H2.899H2.24791V9.78965H1.83472V9.79382H1V5.57429H1.83472V3.09933H1.98497V3.08681H3.90902V1H4.74374V3.94658H3.90902V3.91736H2.66528V5.61185H1.83472V8.9591H2.24791H2.899H3.08264V10.1694H4.32638V9.77713V8.08681V7.26878H5.12354V6.01252H6.41319V8.08681H7.66945V10.1694H8.91319V8.9591H8.98414H9.74791H10.1569V5.99165H9.31803V5.15693ZM6.409 4.06365V3.50021V3.09954H5.57428V2.26899H7.2479V3.09954H7.24373V3.50021H7.66944H8.08263H8.49999V6.01273H7.66944V4.33493H6.409V4.06365Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurnS);
export default __webpack_public_path__ + "static/media/burn-s.758683b49bd5cdd01e7d236f141c8edb.svg";
export { ForwardRef as ReactComponent };